import React, { ReactNode } from "react";

type Props = {
    children: JSX.Element;
  };

const BodyContent = ({ children }: Props) => children

export default BodyContent;